import { cn } from "@/util/functions";
import { Switch } from "@headlessui/react";

const CustomSwitch = ({
  label,
  checked,
  disabled,
  reverse,
  onChange,
  className = "",
}) => {
  const handleKeyUp = (e) => {
    e.preventDefault();
  };

  return (
    <label
      className={cn(
        "tw-inline-flex tw-gap-1 tw-border-none tw-bg-transparent tw-items-center tw-cursor-pointer",
        reverse ? "tw-flex-row-reverse" : ""
      )}
    >
      <Switch
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        onKeyUp={handleKeyUp}
        className={cn(
          "tw-group tw-relative tw-flex tw-h-6 tw-w-10 tw-cursor-pointer tw-rounded-full tw-border-1 tw-border-solid tw-border-gray-400 tw-bg-white tw-p-[2px] tw-transition-colors tw-duration-200 tw-ease-in-out focus:tw-outline-none  data-[focus]:tw-outline-1 data-[focus]:tw-outline-black data-[checked]:tw-bg-[#198754] data-[checked]:tw-border-[#198754]",
          className
        )}
      >
        <span
          aria-hidden="true"
          className="tw-pointer-events-none tw-inline-block tw-size-4 tw-translate-x-0 tw-rounded-full tw-bg-gray-400 tw-ring-0 tw-shadow-lg tw-transition tw-duration-200 tw-ease-in-out group-data-[checked]:tw-translate-x-4 group-data-[checked]:tw-bg-white"
        />
      </Switch>
      {label}
    </label>
  );
};

export default CustomSwitch;
